import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube, FaLink, FaXTwitter } from 'react-icons/fa6';
import { IconType } from 'react-icons';
import { cn } from '@/lib/utils';
interface SocialIconProps extends React.ComponentProps<IconType> {
  name: string;
  colored?: boolean;
}
const iconMap: Record<string, IconType> = {
  Facebook: FaFacebook,
  Twitter: FaXTwitter,
  // Maps Twitter data to X icon
  Instagram: FaInstagram,
  Linkedin: FaLinkedin,
  Youtube: FaYoutube,
  Link: FaLink
};
const brandColors: Record<string, string> = {
  Facebook: '#FFFFFF',
  Twitter: '#FFFFFF',
  // X logo white for visibility on dark background
  Instagram: '#FFFFFF',
  Linkedin: '#FFFFFF',
  Youtube: '#FFFFFF',
  Link: '#FFFFFF'
};
export const SocialIcon = t0 => {
  const $ = _c(17);
  let className;
  let name;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      name,
      className,
      colored: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = name;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    name = $[2];
    props = $[3];
    t1 = $[4];
  }
  const colored = t1 === undefined ? false : t1;
  const IconComponent = iconMap[name] || iconMap.Link;
  let t2;
  if ($[5] !== colored || $[6] !== name || $[7] !== props.style) {
    t2 = colored ? {
      "--icon-color": brandColors[name] || brandColors.Link,
      ...props.style
    } as React.CSSProperties : props.style;
    $[5] = colored;
    $[6] = name;
    $[7] = props.style;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const style = t2;
  const t3 = colored && "text-[var(--icon-color)]";
  let t4;
  if ($[9] !== className || $[10] !== t3) {
    t4 = cn(className, t3);
    $[9] = className;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== IconComponent || $[13] !== props || $[14] !== style || $[15] !== t4) {
    t5 = <IconComponent className={t4} style={style} {...props} />;
    $[12] = IconComponent;
    $[13] = props;
    $[14] = style;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};